import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { AnimationOnScroll } from "vendors/react-animation-on-scroll";
import styles from "./styles.module.css";
function QuizRetake() {
    return (_jsx(_Fragment, { children: _jsxs("div", { className: styles.container, children: [_jsx(AnimationOnScroll, { animateIn: "animate__fadeInDown", className: styles.heading, animateOnce: true, children: "Unsure about your results?" }), _jsx("a", { href: "/users/retake-quiz/", children: _jsx(AnimationOnScroll, { animateIn: "animate__bounceInUp", delay: 500, animateOnce: true, children: _jsx("h3", { className: styles.heading, children: "Retake the quiz" }) }) })] }) }));
}
export default QuizRetake;
